import { useState } from 'react'
import { supabase } from './supabase'

export default function JoinHousehold({ user, onJoined, onSignOut }) {
  const [code, setCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  async function joinHousehold() {
    if (!code.trim()) return
    setLoading(true)
    setError(null)
    const { data: household } = await supabase
      .from('households')
      .select('id')
      .eq('invite_code', code.trim().toLowerCase())
      .maybeSingle()
    if (!household) {
      setError('Code not found. Double-check with the person who invited you.')
      setLoading(false)
      return
    }
    await supabase.from('household_members').delete().eq('user_id', user.id)
    const { error: insertError } = await supabase
      .from('household_members')
      .insert({ user_id: user.id, household_id: household.id })
    if (insertError) {
      setError('Failed to join household. Please try again.')
      setLoading(false)
      return
    }
    onJoined()
  }

  async function createNewHousehold() {
    setLoading(true)
    const inviteCode = Math.random().toString(36).substring(2, 10)
    const { data: newHousehold } = await supabase
      .from('households')
      .insert({ invite_code: inviteCode, custom_categories: [] })
      .select()
      .single()
    if (newHousehold) {
      await supabase.from('household_members').insert({ user_id: user.id, household_id: newHousehold.id })
      onJoined()
    }
    setLoading(false)
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.brand}>bun<span style={styles.brandGreen}>dl</span>e</div>
        <div style={styles.title}>Join a household</div>
        <div style={styles.sub}>
          Enter the invite code from someone already using bundle, or start your own.
        </div>

        <input
          style={styles.input}
          placeholder="Invite code"
          value={code}
          onChange={e => setCode(e.target.value)}
          autoCapitalize="none"
          autoCorrect="off"
        />

        {error && <div style={styles.error}>{error}</div>}

        <button style={styles.btnPrimary} onClick={joinHousehold} disabled={loading || !code.trim()}>
          {loading ? 'Joining…' : 'Join household'}
        </button>

        <div style={styles.dividerRow}>
          <div style={styles.dividerLine} />
          <span style={styles.dividerText}>or</span>
          <div style={styles.dividerLine} />
        </div>

        <button style={styles.btnGhost} onClick={createNewHousehold} disabled={loading}>
          Start a new household
        </button>

        <button style={styles.signOutBtn} onClick={onSignOut}>
          Sign out
        </button>
      </div>
    </div>
  )
}

const styles = {
  container: {
    minHeight: '100vh', background: '#f9f9f7',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'DM Sans', sans-serif", padding: '20px',
  },
  card: {
    background: 'white', borderRadius: '24px', padding: '40px 32px',
    width: '100%', maxWidth: '380px',
    boxShadow: '0 2px 20px rgba(0,0,0,0.06)',
    display: 'flex', flexDirection: 'column', gap: '12px',
  },
  brand: {
    fontFamily: "'DM Serif Display', serif", fontSize: '32px',
    color: '#1a1a18', textAlign: 'center', marginBottom: '4px',
  },
  brandGreen: { color: '#1D9E75' },
  title: {
    fontSize: '18px', fontWeight: '500', color: '#1a1a18', textAlign: 'center',
  },
  sub: {
    fontSize: '13px', color: '#888', textAlign: 'center',
    lineHeight: '1.6', marginBottom: '4px',
  },
  input: {
    padding: '12px 14px', borderRadius: '10px', border: '0.5px solid #ddd',
    fontSize: '14px', fontFamily: "'DM Sans', sans-serif",
    outline: 'none', background: '#f9f9f7', letterSpacing: '0.06em',
  },
  error: {
    background: '#FCEBEB', color: '#A32D2D',
    padding: '10px 14px', borderRadius: '10px', fontSize: '13px',
  },
  btnPrimary: {
    padding: '13px', background: '#1D9E75', color: 'white',
    border: 'none', borderRadius: '12px', fontSize: '14px', fontWeight: '500',
    cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
  },
  dividerRow: {
    display: 'flex', alignItems: 'center', gap: '10px', margin: '4px 0',
  },
  dividerLine: { flex: 1, height: '0.5px', background: '#eee' },
  dividerText: { fontSize: '12px', color: '#bbb' },
  signOutBtn: {
    background: 'none',
    border: 'none',
    fontSize: '12px',
    color: '#aaa',
    cursor: 'pointer',
    fontFamily: "'DM Sans', sans-serif",
    padding: '4px 0',
    textAlign: 'center',
  },
  btnGhost: {
    padding: '11px', background: 'none', border: '0.5px solid #ddd',
    borderRadius: '12px', fontSize: '13px', color: '#888',
    cursor: 'pointer', fontFamily: "'DM Sans', sans-serif",
  },
}
